import { ApplicationIdentificator, NumpadPosition, StringStrategyPowerTasksOptions } from "../../store/settings.store";

export type StudentTestLanguage = 'nl' | 'nl-be' | 'en';

export const DEFAULT_STUDENT_TEST_LANGUAGE: StudentTestLanguage = 'nl';

export interface UserSettings {
  showTimerDuringSpeedTasks?: boolean;
  showTimer?: boolean;
  readSumsAloud: boolean;
  unlimitedTestTime?: boolean;
  unlimitedPracticeTasksSpeedTasks?: boolean;
  numpadPosition: NumpadPosition;
  application: ApplicationIdentificator;
  stringStrategyPowerTasksOptions?: StringStrategyPowerTasksOptions;
  language?: StudentTestLanguage;
  pauseTaskWhenIdle: boolean;
  showInstructionVideo?: boolean;
}

export type UserSettingsPatch = Partial<UserSettings>;

export interface UserSettingsMultipleUpdate {
  userIds: string[];
  settings: UserSettingsPatch;
}
